import AppLayout from "@theme"
import React from "react"

const TestPage = () => {
	return <AppLayout pageTitle="Dashboard">test</AppLayout>
}

export default TestPage
